
























import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import STextarea from '@/common/components/STextarea.vue';

export default defineComponent({
  name: 'UCIrvineELN4OIObjectives2',
  components: {STextarea, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        objectives2Answer: null,
      },
      questions: [
        {
          text: 'Describe the purpose of the experimental work, the general method to be used & the anticipated results in your own words.',
          inputName: 'objectives2Answer',
          maxInputLength: 750,
        },
      ],
    };
  },
});
